import { toast } from '@ethsign/ui';

import { IContact, ICurrentUser } from '@/types';

import { getEnsAddress, WalletType } from '@/utils';

export const getAddressByEns = async (value: string): Promise<string | undefined> => {
  const address = await getEnsAddress(value);
  if (address) {
    return address;
  } else {
    toast({
      title: 'not found',
      variant: 'error',
      description: 'Can not find any address for the entered ENS name.'
    });
    return undefined;
  }
};

export const formatCurrentUser = (currentUser: ICurrentUser): IContact => {
  return {
    telegram: currentUser?.telegramNickName,
    name: currentUser.nickName || currentUser?.ens || currentUser.displayAddress?.slice(0, 6),
    walletAddress: currentUser?.displayAddress,
    network: currentUser?.chainType === WalletType.PARTICLE ? WalletType.EVM : currentUser?.chainType,
    email: currentUser?.email
  };
};
